import {
  createPlatformTheme,
  deletePlatformTheme,
  editPlatformTheme,
  getPlatformThemes
} from 'api/platformThemes';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { IPlatformTheme } from 'types/platformResources';
import { showPlatformApiError } from 'views/PlatformView/platformApiError';
import { NumberNameResourcePanel } from '../NumberNameResourcePanel/NumberNameResourcePanel';

interface Props {
  practiceId: number;
}

export const PracticeThemesTab: React.FC<Props> = ({ practiceId }) => {
  const { t } = useTranslation();
  const [themes, setThemes] = useState<IPlatformTheme[]>([]);

  const load = useCallback(async () => {
    try {
      const response = await getPlatformThemes(practiceId);
      setThemes(response.data);
    } catch (error) {
      showPlatformApiError(error, t);
    }
  }, [practiceId, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <NumberNameResourcePanel
      items={themes}
      onReload={load}
      labels={{
        add: t('platformResources.addTheme'),
        edit: t('platformResources.editTheme'),
        name: t('platformResources.fields.name'),
        number: t('platformResources.fields.number')
      }}
      onCreate={async (data) => {
        try {
          await createPlatformTheme(practiceId, {
            theme: { ...data, practice_id: practiceId }
          });
          return true;
        } catch (error) {
          showPlatformApiError(error, t);
          return false;
        }
      }}
      onUpdate={async (id, data) => {
        try {
          await editPlatformTheme(id, {
            theme: { ...data, practice_id: practiceId }
          });
          return true;
        } catch (error) {
          showPlatformApiError(error, t);
          return false;
        }
      }}
      onDelete={async (id) => {
        try {
          await deletePlatformTheme(id);
          return true;
        } catch (error) {
          showPlatformApiError(error, t);
          return false;
        }
      }}
    />
  );
};
